export { default } from './menu-icon';
